import React from "react";
import logo from "../../Assets/Images/logo.png";

export default function AuthShell({
  title,
  subtitle,
  appName = "HR ERP Core",
  description,
  children,
  extra,
}) {
  return (
    <div className="ems-auth-root">
      <div className="ems-auth-left">
        <div className="ems-auth-card">
          <div className="ems-auth-brand">
            <img src={logo} alt="CORE" className="ems-auth-brand-logo" />
          </div>
          {title ? <h1 className="ems-auth-h">{title}</h1> : null}
          {subtitle ? <p className="ems-auth-sub">{subtitle}</p> : null}
          {children}
        </div>
      </div>

      <div className="ems-auth-right">
        <div className="ems-auth-hero">
          <div className="ems-auth-hero-mark">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
              <path d="M5 8h16M5 13h10M5 18h16" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </div>
          <h2 className="ems-auth-hero-h">{appName}</h2>
          <p className="ems-auth-hero-p">
            {description ||
              "A powerful and flexible solution to manage your system efficiently."}
          </p>
          <div className="ems-auth-trust">
            <span className="ems-auth-trust-dot" />
            Trusted by thousands of users.
          </div>
        </div>
        <div className="ems-auth-copy">
          <p>&copy; {new Date().getFullYear()} Nest Software Pvt. Ltd.</p>
          <p>CORE is a product of Nest Software Pvt. Ltd.</p>
        </div>
      </div>
      {extra}
    </div>
  );
}
